<template>
  <div class="bar-container">
    <div class="create-community-bar">
      <img src="@/assets/CAnnectCommunityBanner.svg" />
      <div
        v-if="communitiesInfos"
        class="communitiesInfos"
      >
        <div class="info">
          <div class="number">
            <span>{{ communitiesInfos.countCommunities }}</span>
          </div>
          <span class="label">{{ $t('community.createCommunityBar.communities') }}</span>
        </div>
        <div class="info">
          <div class="number">
            <span>{{ communitiesInfos.countUsers }}</span>
          </div>
          <span class="label">{{ $t('community.createCommunityBar.users') }}</span>
        </div>
        <div class="info">
          <div class="number">
            <span>{{ communitiesInfos.countPosts }}</span>
          </div>
          <span class="label">{{ $t('community.createCommunityBar.posts') }}</span>
        </div>
      </div>
      <p>{{ $t('community.createCommunityBar.createCommunityInfo') }}</p>
      <v-button
        :on-click="create"
        data-cy="community-create-button"
        class="create-button community"
      >
        {{ $t('community.createCommunityBar.createCommunity') }}
      </v-button>
    </div>
    <modal
      v-if="showModal"
      @close="closeModal"
      class="create-community-modal"
      :height="'590px'"
      :overflow-y="'hidden'"
    >
      <div slot="header">
        {{ $t('community.createCommunityBar.createNewCommunity') }}
      </div>
      <create-community-modal
        slot="body"
        :on-close="closeModal"
      />
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/shared/Modal'
import VButton from '@/components/shared/VButton'
import CreateCommunityModal from '@/components/community/CreateCommunityModal'

export default {
  name: 'CreateCommunityBar',
  components: { CreateCommunityModal, VButton, Modal },
  props: {
    communitiesInfos: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    create() {
      this.showModal = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$left-margin: 24px;

.bar-container {
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 10px 0;
}

.create-community-bar {
  display: flex;
  width: 100%;
  height: 110px;
  overflow: hidden;
  background-color: $secondary-color;
  justify-content: space-between;
  max-width: 77.5rem;
  align-items: center;
  margin: 0 10px;

  @media (max-width: $small) {
    justify-content: center;
    flex-direction: column;
    height: 140px;
    width: 100vw;
  }

  p {
    font-weight: 600;
    text-align: start;
    @media (max-width: $header-change) {
      display: none;
    }
  }

  img {
    height: 100px;
    margin-top: 10px;
    @media (max-width: $medium) {
      display: none;
    }
  }
}

.create-button {
  margin: 22px 24px;

  @media (max-width: $small) {
    margin-top: 0px;
  }

  &.community {
    min-width: 210px;
    background-color: white;
    color: $primary-color;
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    border: thin solid $primary-color;
    padding: 0 10px;

    @media (max-width: $small) {
        min-width: auto;
        white-space: break-spaces;
    }

    &:hover {
      color: white;
      background-color: color.adjust($primary-color, $lightness: 16%);
    }
  }
}

.lined-block {
  background: #FFFFFF;
  box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.20);
  border-radius: 3px;
  max-width: 40rem;
  margin: 1rem;
  border-top: solid 2px $secondary-color;
  text-align: left;
  color: $black-color;
  letter-spacing: 0;
  line-height: 24px;
}

.communitiesInfos {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding-left: 1rem;
  padding-right: 1rem;

  .info {
    display: flex;
    flex-direction: column;
    margin: 0.5rem 1rem 0 1rem;
    align-items: center;
    width: 7rem;
    font-weight: 700;
    @media (max-width: 1200px) {
      width: 5rem;
    }

    @media (max-width: $small) {
      width:2rem;
      margin-left: 1.2rem;
      margin-right: 1.2rem;
    }

    .number {
      height: 50px;
      width: 50px;
      font-size: 20px;
      text-align: left;
      background-color: white;
      border-radius: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      @media (max-width: $small) {
        height: 40px;
        width: 40px;
        font-size: 16px;
      }
    }

    .label {
      font-size: 16px;
      margin: 0.5rem;
      @media (max-width: $small) {
        font-size: 10px;
      }
    }
  }

  .create-community-modal {
    display: flex;
    justify-content: flex-start;
  }
}

</style>
